import { gql } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  LaunchesListItemFragment,
  LaunchesListItemInfo,
} from '../LaunchesListItem/LaunchesListItem';

import { stepStatus } from './stepStatus';

export const LaunchesListFragment = gql`
  fragment LaunchesListFragment on Launch {
    id
    downstreamLaunches {
      id
      ...LaunchesListItemFragment
    }
    supersededBy {
      id
      ...LaunchesListItemFragment
    }
  }
  ${LaunchesListItemFragment}
`;

export interface LaunchesListInfo {
  kind: 'build' | 'launch' | 'supersede';
  launches: LaunchesListItemInfo[];
}

export function computeLaunchesListInfo({
  parentLaunch,
  kind,
}: {
  parentLaunch: GraphQLTypes.LaunchesListFragment;
  kind: LaunchesListInfo['kind'];
}): LaunchesListInfo {
  const launches: GraphQLTypes.LaunchesListItemFragment[] =
    kind === 'supersede'
      ? parentLaunch.supersededBy
        ? [parentLaunch.supersededBy]
        : []
      : parentLaunch.downstreamLaunches
        ? [...parentLaunch.downstreamLaunches]
        : [];
  launches.sort((a, b) =>
    a.graphVariant
      .toLocaleLowerCase()
      .localeCompare(b.graphVariant.toLocaleLowerCase()),
  );

  return {
    kind,
    launches: launches.map((launch) => {
      const { status, progress, isStarted } = stepStatus({
        launch,
        step: kind === 'supersede' ? 'launch' : kind,
      });
      return {
        launch,
        status,
        progress,
        isStarted,
      };
    }),
  };
}
